export enum Types {
  SET_URL = "SET_URL",
  SET_URL_SUCCESS = "SET_URL_SUCCESS",
  SET_EXISTING_URL = "SET_EXISTING_URL",
  RESET_URL = "RESET_URL",
}

export type Action = SetUrlAction | SetUrlSuccessAction | SetExistingUrlAction | ResetUrl

export type SetUrlAction = {
  type: Types.SET_URL
  payload: {
    path: string
    params: any
    arrayParams?: string[]
  }
}

export type SetUrlSuccessAction = {
  type: Types.SET_URL_SUCCESS
  payload: {
    params: any
  }
}

export type ResetUrl = {
  type: Types.RESET_URL
}

export type SetExistingUrlAction = {
  type: Types.SET_EXISTING_URL
  payload: { path: string; arrayParams?: string[]; currentParams?: any }
}

export function setUrl(payload: { path: string; params: any; arrayParams?: string[] }): SetUrlAction {
  return {
    type: Types.SET_URL,
    payload,
  }
}

export function setUrlSuccess(payload: { path: string; params: any }): SetUrlSuccessAction {
  return {
    type: Types.SET_URL_SUCCESS,
    payload,
  }
}

export function setExistingUrl(payload: {
  path: string
  arrayParams?: string[]
  currentParams?: any
}): SetExistingUrlAction {
  return {
    type: Types.SET_EXISTING_URL,
    payload,
  }
}

export function resetUrl(): ResetUrl {
  return {
    type: Types.RESET_URL,
  }
}
